import { FC } from 'react';
import { TitleUnderline } from '@atoms/TitleUnderline';
import { Title } from '@mantine/core';
import { PublicNews } from '@utils/typesPages/types';
import Link from 'next/link';
import { SimpleGridNews } from '@molecules/frontoffice/SimpleGridNews';
import { useTranslation } from 'next-i18next';

export type RecommendedNewsProps = {
  recommendedNews: PublicNews[];
  redirectPath: string;
  title: string;
};

export const RecommendedNews: FC<RecommendedNewsProps> = ({
  recommendedNews,
  redirectPath,
  title,
}) => {
  const { t } = useTranslation('common');

  if (recommendedNews.length === 0) {
    return null;
  }

  return (
    <>
      <Link
        href={redirectPath}
        style={{
          textDecoration: 'none',
          display: 'flex',
          flexDirection: 'column',
          marginBottom: 20,
        }}
      >
        <Title mt={40} variant="h3Orange">
          {t(title)}
        </Title>
        <TitleUnderline />
      </Link>
      <SimpleGridNews news={recommendedNews} />
    </>
  );
};
